import type { PropsWithChildren } from "react";

export function Layout({ children }: PropsWithChildren) {
  return (
    <div className="flex min-h-dvh flex-col bg-slate-100">{children}</div>
  );
}
